import moment from "moment";

export const formatUploadDate = (date: string) => moment(date).format("MMMM D, YYYY h:mm a");
